module.exports = __webpack_public_path__ + "frontend/img/sustainableProfitability.6645c403.svg";